import { useEffect, useState } from "react";

const defaultDebounceTime = 500;

const Debounce = <T extends string | null | number | object>(
  value: T,
  time: number = defaultDebounceTime,
): T | null => {
  const [debounced, setDebounced] = useState<T | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, time);

    return () => {
      clearTimeout(timer);
    };
  }, [time, value]);

  return debounced;
};

export default Debounce;
